// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 实体类型枚举 枚举类
 * 实体类型枚举
 */
export enum EnumBEType {
  /** 接口 : 接口 */
  BEInterface = 1,
  /** 实体 : 实体 */
  BEEntity = 2,
  /** 枚举 : 枚举 */
  BEEnum = 4,
  /** 数据传输对象 : 数据传输对象 */
  BEDTO = 8,
  /** 业务逻辑 : 业务逻辑 */
  BEBusinessLogic = 16,
  /** 值对象 : 值对象 */
  BEValueObject = 32,
  /** 常量 : 常量 */
  BEConstant = 64,
  /** 服务 : 服务 */
  BEService = 128,
  /** 引用实体 : 引用实体 */
  BEReferenceEntity = 256,
  /** 异常 : 异常 */
  BEException = 512,
  /** 配置分组 : 配置分组 */
  BEConfigGroup = 1024,
  /** 分布式事务 : 分布式事务 */
  BEDistributedTransaction = 2048,
  /** 外部服务 : 外部服务 */
  BEExternalService = 4096
}

/**
 * 实体类型枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumBETypeMD {
  private static items = [
    new EnumItemMD('BEInterface', 1, '接口', '接口'),
    new EnumItemMD('BEEntity', 2, '实体', '实体'),
    new EnumItemMD('BEEnum', 4, '枚举', '枚举'),
    new EnumItemMD('BEDTO', 8, '数据传输对象', '数据传输对象'),
    new EnumItemMD('BEBusinessLogic', 16, '业务逻辑', '业务逻辑'),
    new EnumItemMD('BEValueObject', 32, '值对象', '值对象'),
    new EnumItemMD('BEConstant', 64, '常量', '常量'),
    new EnumItemMD('BEService', 128, '服务', '服务'),
    new EnumItemMD('BEReferenceEntity', 256, '引用实体', '引用实体'),
    new EnumItemMD('BEException', 512, '异常', '异常'),
    new EnumItemMD('BEConfigGroup', 1024, '配置分组', '配置分组'),
    new EnumItemMD('BEDistributedTransaction', 2048, '分布式事务', '分布式事务'),
    new EnumItemMD('BEExternalService', 4096, '外部服务', '外部服务')
  ];

  static getItem(enumItem: EnumBEType) {
    return this.items.find(item => item.name === EnumBEType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
